import * as React from 'react';
import { IBaseQuestionProps } from '../FormContainer/types/internal';
import { CardsChoseQuestion } from '../../components/CardsQuestion';
import { useHandleSelect } from './utils/useHandleSelect';
import { pathOr } from 'ramda';
import { QuestionLayoutContainer } from '../QuestionLayoutContainer';
import { useFormTracking } from '../../utils/useFormTracking';

export const CardsChoseQuestionContainer: React.FC<IBaseQuestionProps> = props => {
  const {
    question: { answers, answerField, iconType, title, required },
    answersState,
    setNextStep,
  } = props;

  const { trackSubmit } = useFormTracking();
  const handleSelect = useHandleSelect(props);

  if (!answers) {
    return null;
  }

  const value = pathOr([], [answerField, 'value'], answersState);

  const handleSubmit = () => {
    trackSubmit({
      isRequired: required,
      field: answerField,
      value: value.join(', '),
    });

    setNextStep(answersState);
  };

  const isNextBtnDisabled = required && !value.length;

  return (
    <QuestionLayoutContainer title={title} onSubmit={handleSubmit} disableSubmit={isNextBtnDisabled}>
      <CardsChoseQuestion value={value} handleSelect={handleSelect} iconType={iconType} cards={answers} />
    </QuestionLayoutContainer>
  );
};

CardsChoseQuestionContainer.displayName = 'CardsChoseQuestionContainer';
